import { render, staticRenderFns } from "./JImageUpload.vue?vue&type=template&id=27d1f67e&scoped=true&"
import script from "./JImageUpload.vue?vue&type=script&lang=js&"
export * from "./JImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./JImageUpload.vue?vue&type=style&index=0&id=27d1f67e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d1f67e",
  null
  
)

export default component.exports